import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import Button from '@/components/DesignLibrary/Button';

import s from './Fieldset.module.scss';

export type FieldsetProps = {
  label: string;
  description?: string;
  hint?: string;
  error?: string;
  /** When true, shows the legend label in the error colour without rendering error text below. */
  hasError?: boolean;
  required?: boolean;
  onClear?: () => void;
};

const Fieldset: React.FC<PropsWithChildren<FieldsetProps>> = ({
  label,
  description,
  hint,
  error,
  hasError,
  required,
  children,
  onClear,
}) => (
  <fieldset className={s.container}>
    {((label && label.trim() !== '') || description || onClear) && (
      <legend>
        <div>
          {label && label.trim() !== '' && (
            <p className={classNames('body-sm-bold', (hasError || !!error) && 'text-[var(--color-error)]')}>
              {label}
              {required && <span className='body-sm'>*</span>}
            </p>
          )}
          {description && <p className={classNames('caption', s.description)}>{description}</p>}
        </div>
        {onClear && (
          <Button variant='secondary' className={s.clear} size='xs' onClick={onClear}>
            Clear
          </Button>
        )}
      </legend>
    )}
    {children}
    {(error || hint) && <p className={error ? s.error : s.hint}>{error || hint}</p>}
  </fieldset>
);

export default Fieldset;
